import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {Tab, TabTypes} from '../Tab';
import {actionDeleteDocuments, actionDocumentFetchAll, actionDocumentForIndexingFetchAll} from "../../store/documents";
import {t} from "../../core/localization";
import {ContractList} from "../components/ContractList";
import {Document} from "../../models/Document";
import {ColumnData} from "../../models/ColumnData";
import {IndexingDocument} from "../../models/IndexingDocument";
import {IndexingList} from "../components/IndexingList";
import {type} from "os";
import {Contract} from "../../models/Contract";
import {TabsService} from "../TabsService";


export interface IndexingTabProps {
	tab: Tab
	indexingList: Document[]
}

export interface IndexingTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		tab: state.tabs.active,
		indexingList: state.documents.indexingList
	};
}

class IndexingTab extends React.Component<IndexingTabProps, IndexingTabState> {

	constructor(props: IndexingTabProps) {
		super(props)
	}

	componentDidMount() {
		this.loadData()
	}

	componentWillMount() {
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		const indexingList = this.props.indexingList;

		// var documents: IndexingDocument[] = []
		//
		// for (let doc of indexingList) {
		// 	const document = new IndexingDocument()
		// 	document.title = doc.
		// 	documents.push(document)
		// }

		const columns = [
			new ColumnData(t.Title, "title" )
		];

		return (<div style={{padding: '10px'}}>
			<IndexingList
				columns={columns}
				items={indexingList}
				title={'Dokumenta za indeksiranje'}
				onOpenClick={(document: Document) => this.onOpenClick(document)}
				// onCopyClick={(contract: Contract) => this.onCopyClick(contract)}
				onDeleteClick={(document: Document) => this.onDeleteClick(document)}
				onActionDeleteClick={(documenst: Document[]) => this.onActionDeleteClick(documenst)}
				tab={this.props.tab}
			/>
		</div>)
	}

	onOpenClick(document: Document){
		TabsService.createTab('Dokument' + ': ' + document.title, TabTypes.DOCUMENT_NEW, document)
	}

	onDeleteClick(document: Document) {
		// actionContractDelete(contract);
	}

	onActionDeleteClick(documents: Document[]) {
		actionDeleteDocuments(documents, true);
	}

	private loadData() {
		actionDocumentForIndexingFetchAll()
	}
}

export default connect(mapStateToProps)(IndexingTab);
